import type { ReactNode } from 'react';

import { Box, forwardRef, Popover, PopoverContent, PopoverProps, PopoverTrigger, Portal } from '@bonusly/design-system';
import { Recipient } from '@bonusly/recipient-entities';

import { GroupPopoverContent } from './group-popover-content';

export interface GroupPopoverProps extends PopoverProps {
	children: ReactNode;
	group: Recipient;
	isDisabled?: boolean;
	isExpandable?: boolean;
	onExpand?: (users: Recipient[]) => void;
}

const GroupPopover = forwardRef(({ children, group, isDisabled, isExpandable, onExpand, ...rest }: GroupPopoverProps, ref) => {
	return (
		<Box display="inline-block" ref={ref}>
			<Popover isLazy trigger="hover" isOpen={isDisabled ? false : undefined} {...rest}>
				<PopoverTrigger>{children}</PopoverTrigger>

				<Portal>
					<Box
						sx={{
							'& .chakra-popover__popper': {
								zIndex: 'popover',
							},
						}}
					>
						<PopoverContent borderColor="bg.subtle" boxShadow="xl">
							<GroupPopoverContent group={group} isExpandable={isExpandable} onExpand={onExpand} />
						</PopoverContent>
					</Box>
				</Portal>
			</Popover>
		</Box>
	);
});

GroupPopover.displayName = 'GroupPopover';

export { GroupPopover };
